import React, { ReactElement } from 'react'

function JustificatifeDomicile(): ReactElement {
  return (
    <div className="card py2 px15 cardSm textPrimaryDark w23 fontSizeXs">
      <p>
        <strong>Sont acceptés comme justificatifs de domicile</strong>
      </p>
      <ul className="listUnstyled">
        <li>- Avis d’imposition ou de non imposition</li>
        <li>
          - Facture d’électricité, de gaz, d’eau, de téléphone fixe ou d’accès à
          Internet
        </li>
        <li>- Quittance de loyer d’organisme reconnu</li>
        <li>- Attestation d’assurance logement</li>
        <li>
          - Autre justificatif fiscal datant de moins d’un an : taxe
          d’habitation ou taxe foncière, ou acompte (1er ou 2ème tiers) ou
          bulletin de salaire avec prélèvement à la source
        </li>
      </ul>
    </div>
  )
}

export default JustificatifeDomicile
